export type EmployeesOrder = "name" | "role" | "arrival" | "contractStart";

export class ScheduleEmployeesOrder {
  constructor(
    readonly order: EmployeesOrder = "name",
    readonly reversed = false,
  ) {}

  public sameAs(other: ScheduleEmployeesOrder): boolean {
    return this.order == other.order && this.reversed == other.reversed;
  }
}
